import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import AddSummryDialog from "./AddSummryDialog";
import { showToast } from "src/utils/showToaster";
import { useParams } from "react-router-dom";
import {
  useAddContactNoteMutation,
  useAddContactLogsMutation,
} from "src/services/ContactServices";
import { useGetUserQuery } from "src/services/UserServices";

export type Summary = {
  note: any;
  actionType: string;
  nextActionRequired: boolean;
  nextActionOn: string;
  nextActionDate: any;
  contactedBy: string;
  contactedOnDate: any;
  contactedOnTime: any;
  callOutCome: string;
  callDirection: string;
  meetingOutCome: string;
  meetingDuration: string;
};

type Props = {
  onClose: () => void;
  QueryBy: string;
};

const AddSummryDialogWrapper = ({ onClose, QueryBy }: Props) => {
  const [showInFullWidth, setShowInFullWidth] = useState(false);
  const { contactId } = useParams();
  const [addLog] = useAddContactLogsMutation();
  const [addNote] = useAddContactNoteMutation();

  const { data} = useGetUserQuery({
    limit: 10,
    searchValue: '',
    params: ["firstName", "lastName", "mobile", "email"],
    page: 1,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: false,
  });

  const userOptions = data?.data?.map((el:any)=>{
    return{
      label:el?.userName ,
      value :el?._id
    }
  })

  // Form Initial Values
  const initialValues: Summary = {
    note: "",
    actionType: "",
    nextActionRequired: false,
    nextActionOn: "",
    nextActionDate: "",
    contactedBy: "",
    contactedOnDate: "",
    contactedOnTime: "",
    callOutCome: "",
    callDirection: "",
    meetingOutCome: "",
    meetingDuration: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    note: string().required("Please enter note"),
  });

  // Handle Submit
  const handleSubmit = (
    values: Summary,
    { setSubmitting, resetForm }: FormikHelpers<Summary>
  ) => {
    const formatedValues = {
      contactId: contactId,
      wantToAddReminder: values?.nextActionRequired,
      description: values?.note?.trim(),
      reminderForDate: values?.nextActionDate ,
      reminderRecordSource: values?.actionType,
      reminderOn:values?.nextActionOn || ''
    };

    const formatedLogValues = {
      contactId: contactId,
      logType:QueryBy,
      description: values?.note?.trim(),
      callOutcome: values?.callOutCome,
      direction: values?.callDirection,
      date: values?.contactedOnDate,
      time: values?.contactedOnTime,
      meetingOutcome: values?.meetingOutCome,
      meetingDuration:values?.meetingDuration,
      reminderForDate: values?.nextActionDate ,
      reminderOn:values?.nextActionOn || '',
      reminderRecordSource: values?.actionType,
      wantToAddReminder: values?.nextActionRequired,
      assignedToId : values?.contactedBy
    };

    QueryBy === "NOTE"
      ? addNote(formatedValues).then((res: any) => {
          if (res?.error) {
            showToast("error", res?.error?.data?.message);
          } else {
            if (res?.data?.status) {
              showToast("success", res?.data?.message);
              resetForm();
              onClose();
            } else {
              showToast("error", res?.data?.message);
            }
          }
          setSubmitting(false);
        })
      : addLog(formatedLogValues).then((res: any) => {
          if (res?.error) {
            showToast("error", res?.error?.data?.message);
          } else {
            if (res?.data?.status) {
              showToast("success", res?.data?.message);
              resetForm();
              onClose();
            } else {
              showToast("error", res?.data?.message);
            }
          }
          setSubmitting(false);
        });
  };

  return (
    <Dialog open maxWidth={showInFullWidth ? "xl" : "sm"} fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <AddSummryDialog 
            userOptions={userOptions}
              showInFullWidth={showInFullWidth}
              setShowInFullWidth={setShowInFullWidth}
              QueryBy={QueryBy}
              formikProps={formikProps}
              onClose={onClose}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddSummryDialogWrapper;
